/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import Navbar from "./Navbar";
import Header from "./Header";
import baseUrl from "./BaseUrl";
import Loader from "./Loader";
import { useNavigate , useLocation} from 'react-router-dom';
import Pagination from "react-js-pagination";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { dateFormatter} from "../utils/utils";
 
const BioVital = () => {

    const location = useLocation();
    const abx = location.state;
    console.log(abx);
    const [name, setName] = useState('');
    const [token, setToken] = useState('');
    const [expire, setExpire] = useState('');
    // const [access, setAccess] = useState([]);
    const [popupOpen, setPopupOpen] = useState(false);
    const [users, setData] = useState([]);
    const [userCount, setUserCount] = useState(0);
    const [totalItem, setTotalItem] = useState(0);
    const [bloodGlucoseCount, setBloodGlucoseCount] = useState(0);
    const [bloodPressureCount, setBloodPressureCount] = useState(0);
    const [oxygenSaturationCount, setOxygenSaturationCount] = useState(0);
    const [page, setPage] = useState(1);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [displayFromDate, setDisplayFromDate] = useState("");
    const [displayToDate, setDisplayToDate] = useState("");
    const [searchValue, setSearchValue] = useState('');
    const navigate = useNavigate();


    useEffect(() => {
        refreshToken();
    }, []);

    useEffect(() => {
        setName('Pauser');
        getData('1','','','');
    }, []);

    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/admin/api/token`);
            console.log(response.data.accessToken);
            setToken(response.data.accessToken);
            const decoded = jwtDecode(response.data.accessToken);
            setExpire(decoded.exp);
            console.log(decoded);
        } catch (error) {
           console.log(error.response)
            if (error.response) {
                // setError("Unauthorized");
               navigate("/");  
               window.location.reload();
            }
        }
    }


    const axiosJWT = axios.create();
 
    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/admin/api/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwtDecode(response.data.accessToken);
            setExpire(decoded.exp);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });

    const getData = async (page, fromDate,toDate,search) => {
        // console.log(page);
        setPopupOpen(true);
        const response = await axiosJWT.get(`${baseUrl}/admin/api/bio-vitals?page=${page}&limit=${20}&from_date=${fromDate}&to_date=${toDate}&search=${search}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        //const response = await axios.get(`${baseUrl}/admin/api/get-user?page=${page}&limit=${20}&from_date=${fromDate}&to_date=${toDate}`);

        console.log(response.data);
        setPopupOpen(false);
        setData(response.data.data); // Set the response data
        setTotalItem(response.data.totalItem);
        setBloodGlucoseCount(response.data.bloodGlucoseCount);
        setBloodPressureCount(response.data.bloodPressureCount);
        setOxygenSaturationCount(response.data.oxygenSaturationCount);
        setUserCount(response.data.userCount);
    }

    const handlePageChange  = (pageNumber) => {
        // console.log(`active page is ${pageNumber}`);
        setPage(pageNumber);
        getData(pageNumber,fromDate,toDate,searchValue);
    }
    const handleFromDate = (date) => { 
        console.log(date);  
        const formattedDate =
        date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
         date.getDate().toString().padStart(2, '0');
      
        setFromDate(formattedDate);
        setDisplayFromDate(date);
    };
    const handleToDate = (date) => { 
        console.log(date);  
        const formattedDate =
        date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
         date.getDate().toString().padStart(2, '0');

        setToDate(formattedDate);
        setDisplayToDate(date);
    };

    const handleSearchSubmit = () => {
        setPage(1);
        getData(1,fromDate,toDate,searchValue);
    };

    const handleSearchChange = (e) => {
        setSearchValue(e.target.value);
    };

    const clearFilter = () => {
        setFromDate('');
        setDisplayFromDate('');
        setToDate('');
        setDisplayToDate('');
        setPage(1);
        setSearchValue('');
        getData(1,'','','');
    }

    return (
        <div className="panelbox">
           <Navbar />
            <div className="right-panel">
            <Header name={name} />
            {popupOpen && (
                     <Loader /> 
                ) }
                <div className="content-page">
                    <div className="row">
                        <div className="col-6">
                            <div className="left-title">
                                {users && users.length > 0 && <h1>Bio Vitals</h1>}
                            </div>
                        </div>
                        {/* <div className="col-6">
                            <div className="addnew-button">
                                <Link to="/dashboard"><span>&larr;</span> Back</Link>
                            </div>
                        </div> */}
                    </div>
                    <div className="row numberboxes">
                         <div className="col-md-2">
                            <div className="dashboard-box" id="number">
                                <h3>Total</h3>
                                <p>{totalItem}</p>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="dashboard-box" id="number">
                                <h3>Blood Pressure</h3>
                                <p>{bloodPressureCount}</p>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="dashboard-box" id="number">
                                <h3>Sugar</h3>
                                <p>{bloodGlucoseCount}</p>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="dashboard-box" id="number">
                                <h3>Oxygen Saturation</h3>
                                <p>{oxygenSaturationCount}</p>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="dashboard-box" id="number">
                                <h3>Users</h3>
                                <p>{userCount}</p>
                            </div>
                        </div>
                        
                    </div>

                    <div className="row">
                        <div className="col-md-12 order-filter transection-filter">
                            <div className="boxinput">
                            
                                {/* <input className="search-leave satff-listing-page-search" type="text" name="search" placeholder="Search Order Id" value={searchValue} onChange={handleSearchChange} /> 
                                <input className="search-leave satff-listing-page-search" type="text" name="search" placeholder="Search tn number" value={searchNumberValue} onChange={handleSearchNumberChange} />  */}
                                <input className="search-leave satff-listing-page-search" type="text" name="search" placeholder="Search" value={searchValue} onChange={handleSearchChange} /> 

                                <DatePicker
                                    selected={displayFromDate}
                                    onChange={handleFromDate}
                                    dateFormat="MM/dd/yyyy" // Set the desired date format
                                    placeholderText="From Date"
                                    className="from-date"
                                />
                                <DatePicker
                                    selected={displayToDate}
                                    onChange={handleToDate}
                                    dateFormat="MM/dd/yyyy" // Set the desired date format
                                    placeholderText="To Date"
                                    className="end-date"
                                />  
                                
                                <button  className="search-btn" onClick={handleSearchSubmit}>Search</button>
                               { (fromDate || toDate || searchValue) && (<button type="button" className='search-btn clear-btn' onClick={clearFilter}>Clear</button>)}
                            </div>
                        </div>
                        
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="fullwidth-table track-table-body staff-listing-admin-table-body">
                                <table className="table is-striped is-fullwidth">
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>BP(systolic/diastolic)</th>
                                            <th>Sugar</th>
                                            <th>Oxygen Saturation</th>
                                            <th>Datetime</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {users && users.map((user, index) => (
                                            <tr key={user.id}>
                                                <td data-label="No">{index+1}</td>
                                                <td data-label="Name">{user.name}</td>
                                                <td data-label="Email">{user.email}</td>
                                                <td data-label="BP(systolic/diastolic)">{user.data_type==='blood_pressure' ? user.value : "-"}</td>
                                                <td data-label="Sugar">{user.data_type==='blood_glucose' ? user.value : "-"}</td>
                                                <td data-label="Oxygen Saturation">{user.data_type==='oxygen_saturation' ? user.value : "-"}</td>
                                                <td data-label="Datetime">{(user.created_at) ? dateFormatter(user.created_at) : '-'}</td>
                                            </tr>
                                        ))
                                    }
                                    </tbody>
                                </table>
                                {totalItem > 20 && (<Pagination
                                  activePage={page}
                                  itemsCountPerPage={20}
                                  totalItemsCount={totalItem}
                                  pageRangeDisplayed={5}
                                  onChange={handlePageChange.bind(this)}
                                />)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    )
}
 
export default BioVital